import { render } from "./CouponManagement.vue?vue&type=template&id=6b2a26e0&scoped=true"
import script from "./CouponManagement.vue?vue&type=script&lang=js"
export * from "./CouponManagement.vue?vue&type=script&lang=js"

import "./CouponManagement.vue?vue&type=style&index=0&id=6b2a26e0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2a26e0"]])

export default __exports__